import { useState, useEffect } from "react";

const useScreenHeight = () => {
    const getStored = () => {
        const h = sessionStorage.getItem("screenHeight");
        const s = sessionStorage.getItem("screenScaling");
        return {
            height: h ? Number(h) : null,
            scaling: s ? Number(s) : null,
        };
    };

    const calculatePageSize = (height, scaling) => {
        if (height < 600) {
            return 5;
        } else if (height < 622 && scaling === 1.5) {
            return 10;
        } else if (height < 767 && scaling === 1.25) {
            return 12;
        } else if (height < 981 && scaling === 1) {
            return 18;
        } else {
            return 12;
        }
    };

    const [{ height, scaling }, setValues] = useState(() => {
        const stored = getStored();
        if (stored.height && stored.scaling) return stored;
        return { height: window.innerHeight, scaling: window.devicePixelRatio };
    });

    const [pageSize, setPageSize] = useState(() => {
        const stored = getStored();
        const h = stored.height || window.innerHeight;
        const s = stored.scaling || window.devicePixelRatio;
        return calculatePageSize(h, s);
    });

    useEffect(() => {
        const update = () => {
            const next = {
                height: window.innerHeight,
                scaling: window.devicePixelRatio,
            };
            setValues(next);
            setPageSize(calculatePageSize(next.height, next.scaling));
            sessionStorage.setItem("screenHeight", String(next.height));
            sessionStorage.setItem("screenScaling", String(next.scaling));
        };

        update();

        window.addEventListener("resize", update);
        window.addEventListener("orientationchange", update);
        return () => {
            window.removeEventListener("resize", update);
            window.removeEventListener("orientationchange", update);
        };
    }, []);
    console.log(
            "HOOK → screenHeight:",
            height,
            "screenScaling:",
            scaling
        );
    return { 
        screenHeight: height, 
        screenScaling: scaling, 
        pageSize 
    };
};

export default useScreenHeight;